import { put } from "redux-saga/effects";
import axiosGovernorate from "../../axios-governorate";
import * as actions from "../actions";

export function* chooseTreasureSaga({ treasure, generalId }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "chooseTreasure",
      generalId,
      treasure
    });

    const { data } = JSON.parse(response.data);
    if (data.resources) {
      yield put(actions.updateResources({
        resources: data.resources,
        resourceBalances: data.resourceBalances
      }));
    }

    if (data.general) {
      yield put(actions.updateGeneral(
        data.general,
      ));
    }

    if (data.generals) {
      yield put(actions.updateGenerals(
        data.generals,
      ));
    }

    const {
      hasFinishedQuest,
      availableQuests,
      finishedQuests,
      labyrinthAttempt,
      canDoLabyrinth,
      ljpPoints,
      magicResearch,
      slotChains,
      army,
      development
    } = data;

    yield put(actions.updateState({
      labyrinthAttempt,
      canDoLabyrinth,
      ljpPoints
    }));

    if (hasFinishedQuest) {
      yield put(actions.updateState({
        hasFinishedQuest,
        availableQuests,
        finishedQuests
      }));
    }

    if (magicResearch) {
      yield put(actions.updateState({
        magicResearch
      }));
    }

    if (development) {
      yield put(actions.updateState({
        development
      }));
    }

    if (slotChains) {
      yield put(actions.updateState({
        slotChains
      }));
    }

    if (army) {
      yield put(actions.updateState({
        army
      }));
    }

    if (data.result) {
      yield put(actions.openContentPopup({
        name: "LabyrinthResult",
        title: "Labyrinth",
        icon: "labyrint",
        header: data.result.header,
        text: data.result.text,
        amount: data.result.amount,
        footer: data.result.footer,
        imageCode: data.result.number
      }))
    }
  } catch (error) {
    console.log(error.message);
  }
}
